import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './social-share.scss.js';

class SocialShare extends s {
    render() {
        return $ `<div class="social"><p class="social__heading">${o(this.heading)}</p><div class="row social__links"><slot name="social-link"></slot></div></div>`;
    }
}
SocialShare.styles = css_248z;
__decorate([
    e({ type: String })
], SocialShare.prototype, "heading", void 0);
customElements.define('social-share', SocialShare);

export { SocialShare };
